import { render } from "./BaseIncentiveRedirectComponent.vue?vue&type=template&id=8b1cb258&ts=true"
import script from "./BaseIncentiveRedirectComponent.vue?vue&type=script&lang=ts"
export * from "./BaseIncentiveRedirectComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__